<div class="field-renderer" [class.field-renderer--error]="showError">

  <!-- ── Icona informativa (opzionale) ────────────────────────────────── -->
  @if (showInfo) {
    <button
      type="button"
      class="field-info-btn"
      (click)="openInfo()"
      aria-label="Informazioni sul campo"
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
           stroke-linecap="round" stroke-linejoin="round" width="18" height="18" aria-hidden="true">
        <circle cx="12" cy="12" r="10"/>
        <line x1="12" y1="16" x2="12" y2="12"/>
        <line x1="12" y1="8" x2="12.01" y2="8"/>
      </svg>
    </button>
  }

  <!-- ── Dispatch al componente corretto ──────────────────────────────── -->
  @if (control()) {
    @switch (field().type) {

      @case ('text') {
        <app-text-field [field]="field()" [control]="control()"/>
      }
      @case ('number') {
        <app-text-field [field]="field()" [control]="control()"/>
      }
      @case ('email') {
        <app-text-field [field]="field()" [control]="control()"/>
      }
      @case ('tel') {
        <app-text-field [field]="field()" [control]="control()"/>
      }
      @case ('date') {
        <app-text-field [field]="field()" [control]="control()"/>
      }
      @case ('password') {
        <app-password-field [field]="field()" [control]="control()"/>
      }
      @case ('textarea') {
        <app-textarea-field [field]="field()" [control]="control()"/>
      }
      @case ('dropdown') {
        <app-dropdown-field [field]="field()" [control]="control()"/>
      }
      @case ('multiselect') {
        <app-multiselect-field [field]="field()" [control]="control()"/>
      }
      @case ('radio') {
        <app-radio-field [field]="field()" [control]="control()"/>
      }
      @case ('checkbox') {
        <app-checkbox-field [field]="field()" [control]="control()"/>
      }
      @case ('module-toggle') {
        <app-module-toggle-field [field]="field()" [control]="control()"/>
      }
      @case ('secret-state') {
        <app-secret-state-field [field]="field()" [control]="control()"/>
      }
      @case ('acceptance') {
        @if (field().acceptance) {
          <!--
            L'AcceptanceFieldComponent gestisce internamente
            il proprio errore inline, quindi NON serve il <span class="field-error"> qui.
          -->
          <app-acceptance-field
            [acceptance]="field().acceptance!"
            [control]="control()"
          />
        }
      }

    }
  }

  <!-- ── Messaggio errore inline per tutti i tipi tranne 'acceptance' ─── -->
  @if (showError) {
    <span class="field-error" role="alert" aria-live="polite">
      {{ control().errors | validationMessage }}
    </span>
  }

</div>
